import React from 'react'
import './header.scss'
import logoAP from '../../images/AP/ap-small-logo.svg'
import CONSTANTS from '../../Constants';

function Header() {
  const logo = logoAP // we only have peugept for now
  return (
    <>
      <header>
        <div className='header-container'>
          <div className='header-area'>
            <img className='logo' src={logo} alt={'Peugeot'} />
            <div className='headline' > {CONSTANTS.LABELS.dealer_locator_titlequote} </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
